import React from 'react';

import './NonExistantDatasetsPrinting.scss';

type NonExistantDatasetsPrintingProps = {
    datasetsArray: Array<string>
}

const NonExistantDatasetsPrinting = (props: NonExistantDatasetsPrintingProps) => {
    return (
        <div className={"main-frame"}>
            <div className={"non-main-frame"}>
                <div className={"font-style"}>Following datasets were not found:</div>
                    {
                        props.datasetsArray.map((ob, i) => {
                            return <div className={"table-row"} key={i}>
                                {ob}
                            </div>
                        })
                    }
            </div>
        </div>
    );
}

export default NonExistantDatasetsPrinting;